module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGames/nba/survive-568072429343f49e2559706f3b4ffc5f.svg";